export enum UserChallengeStatus {
  COMPLETED = "Completed",
  FINISHED = "Finished",
  SENT = "Sent",
  PENDING = "Pending",
  CLOSED = "Closed",
  REJECTED = "Rejected",
  /** @deprecated Prefer `Completed`. */
  APPROVED = "Approved",
}

export enum TaskChallengeStatus {
  APPROVED = "Approved",
  FINISHED = "Finished",
  SENT = "Sent",
  PENDING = "Pending",
  REJECTED = "Rejected",
}

export enum MediaType {
  PHOTO = "Photo",
  VIDEO = "Video",
}
